import { TypedUseSelectorHook, useSelector } from "react-redux";
import { Application } from "../store";

export const useTypedSelector: TypedUseSelectorHook<Application> = useSelector;
